import Skeleton from "react-loading-skeleton";

import Box from "ds/components/Box";
import Card from "ds/components/Card";

const ChapterSectionSkeleton = () => (
  <Box direction="column" gap="medium" padding="x-large">
    {/* Chapter header - title and completion count */}
    <Box direction="row" justify="between" align="center">
      <Skeleton width={180} height={18} borderRadius={4} />
      <Skeleton width={90} height={14} borderRadius={4} />
    </Box>

    {/* Guide cards */}
    <Box direction="column" gap="medium">
      {Array.from({ length: 2 }).map((_, index) => (
        <Card key={index}>
          <Box direction="row" justify="between" align="center" fullWidth>
            <Box direction="column" gap="small">
              <Skeleton width={160} height={16} borderRadius={4} />
              <Box direction="row" align="center" gap="small">
                <Skeleton width={14} height={14} borderRadius={4} />
                <Skeleton width={70} height={12} borderRadius={4} />
              </Box>
            </Box>
            <Skeleton width={56} height={28} borderRadius={4} />
          </Box>
        </Card>
      ))}
    </Box>
  </Box>
);

const UserGuideGroupSkeleton = () => (
  <Box direction="column" gap="large" grow="1" overflowHidden>
    <Box direction="column" gap="medium" grow="1">
      {Array.from({ length: 3 }).map((_, index) => (
        <ChapterSectionSkeleton key={index} />
      ))}
    </Box>
  </Box>
);

export default UserGuideGroupSkeleton;
